export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo:
        'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Turvallinen maksusivu',
      description: 'Pidämme taloudellisia tietojasi turvallisesti salattuna',
      methodErrorTips:
        'Valitettavasti valitsemaasi maata ei tällä hetkellä tueta. Ole hyvä ja valitse toinen maa ja yritä uudelleen.',
      recommendation: 'Suositus',
      cardNumber: 'Kortin numero',
      cardName: 'Kortilla oleva nimi',
      cvv: 'CVV',
      expiredDate: 'Vanhenemispäivä',
      billingInfo: 'Laskutustiedot',
      country: 'Maa',
      state: 'Osavaltio',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      document: 'Dokumentti',
      city: 'Kaupunki',
      address: 'Osoite',
      streetNumber: 'Kadun numero',
      zipCode: 'Postinumero',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      pay: 'Maksa',
      choosePaymentMethod: 'Valitse maksutapa',
      continue: 'Jatka',
      later: 'Myöhemmin',
      returnToMerchant: 'Peruuta ja palaa kauppiaaseen',
      resultToMerchant: 'Palaa kauppiaaseen',
      orderId: 'Tilausnumero',
      orderAmount: 'Tilausmäärä',
      billingDescriptor: 'Laskutuskuvaus',
      goodsName: 'Tuotenimi',
      timeLimit: 'Varoitus: Suorita maksu määräajan kuluessa, muuten sivu vanhenee.',
      otherPaymentMethods: 'Muu maksutavat',
      close: 'Sulje',
      paymentErrorTitle: 'Maksaminen epäonnistui',
      paymentErrorTip: 'Maksusi ei käsitelty onnistuneesti. Yritä uudelleen.',
      paymentFailed: 'Maksuprosessi epäonnistui',
      continueShopping: 'Jatka shoppailua',
      paymentSuccess: 'Maksuprosessi onnistui',
      paymentPending: 'Maksu lähetetty, vahvistetaan',
      correctDateTip: 'Anna kelvollinen vanhenemispäivämäärä',
      correctCardNumberTip: 'Anna kelvollinen korttinumero',
      correctSecurityCodeTip: 'Ole hyvä ja syötä voimassaoleva turvakoodi',
      mobileMoneyOperator: 'Matkapuhelinrahan operaattori',
      bank: 'Pankki',
      correctEmailAddressTip: 'Syötä kelvollinen sähköpostiosoite',
      notSupportPaymentTip: 'Nykyinen ympäristö ei tue {type} -maksua',
      addValidPaymentCard: 'Lisää kelvollinen maksukortti',
      timeLimitTip: 'Maksu veloitetaan 12 tuntia ennen kokeilujakson päättymistä (<span class="date">{date}</span>), minkä jälkeen se uusitaan joka <span class="date">{month}</span>. kuukausi <span class="amount"> {amount} {currency}</span> -summalla, peruutus on mahdollista milloin tahansa',
      product: 'Tuote/palvelu',
      subscribeType: 'Tilaustyyppi',
      renewCycle: 'Uusimisjakso',
      renewAmount: 'Uusimissumma',
      subscribePay: 'Tilaa ja maksa',
      readAgreement: "Lue ja hyväksy<span class='protocol-link' style='color: #31a7da;'>《Automaattisen uusimisen sopimus》</span>",
      depict: 'Kuvaus',
      copyQrCode: 'Kopioi QR-Code',
      copySuccess: 'QR-Code kopioitu onnistuneesti',
      copyError: 'QR-Code ei kopioitu',
      refreshQrCode: 'Pivottaa QR-Code'
    },
    subscribe: {
      yourSubscribe: 'Tilauksesi',
      unsubscribeTip: 'Jos haluat peruuttaa, napsauta [Peruuta tilaus] -painiketta sivun alaosassa.',
      renewTip: '<span class="date">{date}</span> veloitetaan <span class="amount"> {amount} {currency}</span>, voit peruuttaa milloin tahansa',
      unsubscribe: 'Peruuta tilaus',
      autoRenew: 'Automaattisen uusimisen sopimus',
      unsubscribeTipTwo: 'Jos peruutat nyt, voit käyttää tätä tilausta edelleen <span class="date">{date}</span> asti.',
      emailVerifyTip: 'Sähköpostin vahvistus',
      inputCodeTip: 'Syötä vahvistuskoodi',
      sendSuccessTip: 'Vahvistuskoodi lähetetty onnistuneesti',
      sendErrorTip: 'Vahvistuskoodin lähetys epäonnistui',
      unsubscribeSuccessTip: 'Tilauksen peruutus onnistui',
      unsubscribeErrorTip: 'Tilauksen peruutus epäonnistui',
      sendCodeTip: 'Lähetä uudelleen {code} sekunnin kuluttua',
      sendEmailTip: 'Hae vahvistuskoodi',
      daily: 'joka päivä',
      weekly: '7 päivän välein',
      monthly: '30 päivän välein',
      quarterly: '90 päivän välein',
      semiAnnually: '180 päivän välein',
      annually: '365 päivän välein',
      regularRenewal: 'Säännöllinen uusiminen',
      oneTime: 'Kertamaksu',
      inputNumberTip: 'Syötä vain luvut',
      eachCalendarMonth: 'Jokainen kalenterikuukausi'
    },
    common: {
      confirm: 'Vahvista',
      cancel: 'Peruuta',
      uploadImgErrorTip: 'Vain kuvia voi ladata',
      inputMessageTip: 'Ole hyvä ja täytä sisältö',
      sendSuccessTip: 'Lähetys onnistui',
      sendErrorTip: 'Lähetystä epäonnistui',
      inputPlaceholder: 'Ole hyvä ja syötä {field}',
      selectPlaceholder: 'Ole hyvä ja valitse {field}',
      correctFormat: 'Syötä oikea muoto, esimerkiksi: {example}'
    }
  }
}
